// TenantPickerScreen — user belongs to 2+ tenants, picks the active one.
// Faithful port of the design bundle (screens-auth.jsx · AuthTenantPicker),
// driven by the real memberships from POST /auth. The choice is persisted via
// selectTenant() (CloudStorage) and used as active_tenant on subsequent calls.
import { useState } from 'react'

import { useAuth } from '../auth/AuthProvider'
import { AuthTopBar } from '../components/AuthTopBar'
import { getWebApp } from '../telegram/tg'
import { Button, Icon, t } from '../design'

export function TenantPickerScreen() {
  const { memberships, activeTenantId, selectTenant } = useAuth()
  const [sel, setSel] = useState<number>(activeTenantId ?? memberships[0]?.tenant_id)
  const close = () => {
    try { getWebApp()?.close() } catch { /* noop outside Telegram */ }
  }

  return (
    <>
      <AuthTopBar onBack={close} />
      <div className="scroll-y" style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 14, padding: '18px 16px' }}>
        <div>
          <div className="t-h1" style={{ marginBottom: 4 }}>{t('auth.picker.title')}</div>
          <div className="t-caption">{t('auth.picker.sub')}</div>
        </div>

        <div className="col" style={{ gap: 10 }}>
          {memberships.map((m) => {
            const active = sel === m.tenant_id
            const isDir = m.role === 'director'
            return (
              <button
                key={m.tenant_id}
                onClick={() => setSel(m.tenant_id)}
                style={{
                  width: '100%', textAlign: 'left', cursor: 'pointer',
                  display: 'flex', alignItems: 'center', gap: 12, padding: '14px',
                  borderRadius: 14, background: 'var(--surface)',
                  border: `1.5px solid ${active ? 'var(--brand-500)' : 'var(--border)'}`,
                  boxShadow: active ? '0 0 0 3px color-mix(in srgb, var(--brand-500) 14%, transparent)' : 'none',
                  transition: 'border-color 0.12s, box-shadow 0.12s',
                }}
              >
                <span style={{
                  width: 46, height: 46, borderRadius: 12, flexShrink: 0,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: isDir ? 'color-mix(in srgb, var(--ai) 14%, transparent)' : 'var(--brand-100)',
                  color: isDir ? 'var(--ai)' : 'var(--brand-900)',
                }}>
                  <Icon.Briefcase size={22} sw={2} />
                </span>
                <div className="flex-1" style={{ minWidth: 0 }}>
                  <div className="row middle gap-2">
                    <span className="t-body" style={{ fontWeight: 650 }}>{m.tenant_name}</span>
                  </div>
                  <div className="t-caption" style={{ marginTop: 2 }}>
                    {t(isDir ? 'auth.picker.role.director' : 'auth.picker.role.manager')}
                    <span style={{ color: 'var(--text-3)' }}> · Bitrix </span>
                    <span className="t-mono" style={{ color: 'var(--text-3)' }}>{m.bitrix_user_id}</span>
                  </div>
                </div>
                <span style={{
                  width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  border: `2px solid ${active ? 'var(--brand-500)' : 'var(--border-strong, var(--border))'}`,
                  background: active ? 'var(--brand-500)' : 'transparent', color: '#fff',
                }}>
                  {active && <Icon.Check size={13} sw={3} />}
                </span>
              </button>
            )
          })}
        </div>

        <div style={{ flex: 1 }} />
        <div className="row gap-2" style={{ alignItems: 'flex-start', color: 'var(--text-3)', padding: '0 2px' }}>
          <Icon.Cloud size={14} sw={2} style={{ marginTop: 1, flexShrink: 0 }} />
          <span className="t-caption" style={{ color: 'var(--text-3)' }}>{t('auth.picker.save')}</span>
        </div>
        <Button variant="primary" full icon={<Icon.ArrowRight size={16} sw={2.5} />} onClick={() => void selectTenant(sel)}>
          {t('auth.picker.cta')}
        </Button>
      </div>
    </>
  )
}
